import cookie from 'react-cookies'
// 设置一个cookie
export function setCookie(key: string, value: string, options: any = {}) {
    return cookie.save(key, value, options);
}

// 获取一个cookie值
export function getCookie(key: string): string | null {
    return cookie.load(key);
}

// 删除一个cookie
export function removeCookie(key: string): void {
    cookie.remove(key);
}

// 获取所有cookie
export function getAllCookies(): Record<string, string> {
    return cookie.loadAll();
}

// 设置一个带有过期时间的cookie
export function setCookieWithTimeLimit(
    key: string,
    value: string,
    expires: number,
    options: any = {}
) {
    const optionsWithExpiration = { ...options, expires: expires };
    setCookie(key, value, optionsWithExpiration);
}

// 检查一个cookie是否已过期
export function isExpiredCookie(key: string): boolean {
    const cookieValue = getCookie(key);
    return cookieValue === null || cookieValue === '';
}

// 检查一个cookie是否在给定的过期时间范围内过期
export function hasExpiredCookie(key: string, maxAge: number): boolean {
    const cookieValue = getCookie(key);
    return cookieValue === null || cookieValue === '' || Date.now() - parseInt(cookieValue, 10) > maxAge * 1000;
}